import React, { useEffect } from 'react'

interface ToastProps {
    message: string
    type?: 'error' | 'success' | 'info' | 'warning'
    isVisible: boolean
    onClose: () => void
    duration?: number
}

export default function Toast({ 
    message, 
    type = 'info', 
    isVisible, 
    onClose, 
    duration = 5000 
}: ToastProps) {
    useEffect(() => {
        if (isVisible && duration > 0) {
            const timer = setTimeout(() => {
                onClose()
            }, duration)
            return () => clearTimeout(timer)
        }
    }, [isVisible, duration, onClose])

    if (!isVisible) return null

    const typeStyles = {
        error: 'bg-red-500 text-white',
        success: 'bg-green-500 text-white',
        info: 'bg-blue-500 text-white',
        warning: 'bg-yellow-500 text-black'
    }

    return (
        <div className="fixed top-4 right-0 z-50 animate-slide-in" style={{ width: '50%' }}>
            <div className={`${typeStyles[type]} rounded-lg shadow-lg px-6 py-4 flex items-center justify-between mr-4`}>
                <p className="text-sm font-medium flex-1">{message}</p>
                <button
                    onClick={onClose}
                    className="ml-4 text-white hover:text-gray-200 focus:outline-none flex-shrink-0"
                    aria-label="Cerrar"
                >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>
    )
}

